import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import Advantages from '../components/Advantages';
import About from '../components/About';
import Pricing from '../components/Pricing';
import ReviewsSection from '../components/ReviewsSection';
import PartnersSection from '../components/PartnersSection';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <>
      <SEO
        title="Garage & Carrosserie à Genève | Entretien automobile sur abonnement — CarMaintenance"
        description="Garage et carrosserie à Genève. CarMaintenance, le premier abonnement tout-inclus pour l'entretien et la réparation de votre voiture : mécanique, carrosserie, pneus, diagnostic, véhicule de remplacement. À partir de CHF 49/mois."
        path="/"
        image="/generated/hero-swiss-road.jpg"
      />
      <Hero />
      <Advantages />
      <About />
      <Pricing />
      <ReviewsSection />
      <PartnersSection />
      <FAQ />
      <CTASection />
    </>
  );
};

export default Home;
